export default __webpack_public_path__ + "static/media/email.37b9e890.png";